import { render, staticRenderFns } from "./ArmageddonButton.vue?vue&type=template&id=bf043718&scoped=true"
import script from "./ArmageddonButton.vue?vue&type=script&lang=js"
export * from "./ArmageddonButton.vue?vue&type=script&lang=js"
import style0 from "./ArmageddonButton.vue?vue&type=style&index=0&id=bf043718&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf043718",
  null
  
)

export default component.exports